/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Invalid_StateInputs */



/**
* | output |
* | --- |
* | "Invalid user component state" |
*
* @param {User_Invalid_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_invalid_state = /** @type {((inputs?: User_Invalid_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Invalid_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("État du composant utilisateur invalide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado de componente de usuario inválido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Estado inválido do componente de usuário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato componente utente non valido")
	return /** @type {LocalizedString} */ ("Invalid user component state")
});